import { axiosInstance } from './api';

export interface PlanDraftParams {
  camera_id: number;
  from: string;            // YYYY-MM-DD
  to: string;              // YYYY-MM-DD
  min_score: number;
  min_box_h_px: number;
  max_box_h_px: number;
  min_aspect: number;
  min_isolation_px: number;
  grid_cols?: number;
  grid_rows?: number;
  max_sample?: number;
}

export interface PlanDraftResponse {
  camera: {
    id: number;
    name: string | null;
    image_size: { w: number; h: number };
    image_url: string | null;
  };
  from: string;
  to: string;
  params: Record<string, number>;
  counts: {
    raw: number;
    after_score: number;
    after_size: number;
    after_aspect: number;
    after_isolation: number;
    truncated: boolean;
  };
  density: {
    cols: number;
    rows: number;
    max: number;
    /** Row-major, length = cols × rows. Raw counts (not normalized). */
    values: number[];
  };
  /** Up to `max_sample` clean foot points in pixel coords, [x, y]. */
  sample_points: [number, number][];
  sql_floors: {
    min_score: number;
    min_box_h_norm: number;
    max_candidates: number;
  };
}

export async function fetchPlanDraft(params: PlanDraftParams): Promise<PlanDraftResponse> {
  const res = await axiosInstance.get<PlanDraftResponse>('/core/api/plan-draft/', {
    params,
    // Cold candidate-set scan over a 7-day window can take ≥30 s on a busy
    // camera; subsequent slider tweaks hit the in-memory candidate cache and
    // return in <1 s.
    timeout: 90_000,
  });
  return res.data;
}
